module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [(_vm.rowData.sharers > 0) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.utilLabel) + " " + _vm._s(_vm.rowData.period) + " Details for " + _vm._s(_vm.rowData.siteName))]), _vm._v(" "), _c('utility-sharing-table', {
    attrs: {
      "row-data": _vm.rowData,
      "site-id": _vm.rowData.site_id
    }
  })], 1) : _c('div', [_c('center', [_c('h3', [_vm._v("No sharers found")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ce840c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/utility/UtilityReportDetails.vue
// module id = 1659
// module chunks = 0